(function () {
  var prefetchedUrls = {};

  function isNarrow() {
    return window.matchMedia && window.matchMedia('(max-width: 798px)').matches;
  }

  function shouldPrefetch() {
    if (isNarrow()) return false;
    var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (!conn) return true;
    if (conn.saveData) return false;
    if (conn.effectiveType === 'slow-2g' || conn.effectiveType === '2g') return false;
    return true;
  }

  function applyDeferredImage(img) {
    if (!img || img.hasAttribute('data-mm-loaded')) return;

    var src = img.getAttribute('data-mm-defer-src');
    var srcset = img.getAttribute('data-mm-defer-srcset');

    img.setAttribute('data-mm-loaded', '');

    var w = img.getAttribute('data-mm-width');
    var h = img.getAttribute('data-mm-height');
    if (w) img.setAttribute('width', w);
    if (h) img.setAttribute('height', h);

    if (isNarrow()) {
      if (src) img.src = src.replace(/width=\d+/g, 'width=400');
      return;
    }

    if (srcset) {
      img.setAttribute('srcset', srcset);
    }

    if (src) {
      img.src = src;
    }
  }

  function loadDeferredImages(root) {
    if (!root) return;

    var imgs = root.querySelectorAll('img[data-mm-defer-src]:not([data-mm-loaded])');
    if (!imgs.length) return;

    if (!isNarrow() || !('IntersectionObserver' in window)) {
      imgs.forEach(applyDeferredImage);
      return;
    }

    var scrollRoot = document.querySelector('#header .mobile-menu-container');
    var observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          applyDeferredImage(entries[i].target);
          observer.unobserve(entries[i].target);
        }
      },
      { root: scrollRoot || null, rootMargin: '80px 0px', threshold: 0.01 }
    );

    imgs.forEach(function (img) {
      observer.observe(img);
    });
  }

  function groupUnloadedImages() {
    var groups = {};

    document.querySelectorAll('img[data-mm-defer-src]:not([data-mm-loaded])').forEach(function (img) {
      var src = img.getAttribute('data-mm-defer-src');
      if (!src) return;

      if (!groups[src]) {
        groups[src] = {
          src: src,
          srcset: img.getAttribute('data-mm-defer-srcset'),
          sizes: img.getAttribute('sizes'),
          imgs: [],
        };
      }

      groups[src].imgs.push(img);
    });

    return Object.keys(groups).map(function (key) {
      return groups[key];
    });
  }

  function prefetchImageGroup(group) {
    return new Promise(function (resolve) {
      if (prefetchedUrls[group.src]) {
        group.imgs.forEach(applyDeferredImage);
        resolve();
        return;
      }

      var loader = new Image();
      loader.decoding = 'async';

      if (group.srcset) {
        loader.srcset = group.srcset;
        if (group.sizes) loader.sizes = group.sizes;
      }

      var finish = function () {
        prefetchedUrls[group.src] = true;
        group.imgs.forEach(applyDeferredImage);
        resolve();
      };

      loader.onload = finish;
      loader.onerror = finish;
      loader.src = group.src;
    });
  }

  function prefetchMegaMenuImages() {
    if (!shouldPrefetch()) return;

    var groups = groupUnloadedImages();
    if (!groups.length) return;

    groups.reduce(function (chain, group) {
      return chain.then(function () {
        return prefetchImageGroup(group);
      });
    }, Promise.resolve());
  }

  function scheduleBackgroundPrefetch() {
    if (isNarrow()) return;

    var run = function () {
      prefetchMegaMenuImages();
    };

    if ('requestIdleCallback' in window) {
      requestIdleCallback(run, { timeout: 5000 });
    } else {
      setTimeout(run, 1500);
    }
  }

  function loadDesktopPanelImages(details) {
    if (isNarrow() || !details) return;

    var container = details.querySelector('[data-meganav-target-container]')
      || details.querySelector('[data-nav-desktop-submenu]')
      || details;

    loadDeferredImages(container);
  }

  function scanOpenDesktopPanels(root) {
    if (!root) return;

    root.querySelectorAll('[data-nav-desktop-details][open]').forEach(loadDesktopPanelImages);
  }

  function eventTargetElement(event) {
    var node = event && event.target;
    if (!node) return null;
    if (node.nodeType === 1 && typeof node.closest === 'function') return node;
    var parent = node.parentElement;
    if (parent && typeof parent.closest === 'function') return parent;
    return null;
  }

  function observeDesktopMegaMenus() {
    var header = document.querySelector('[data-desktop-header]') || document.querySelector('[data-nav-desktop]');
    if (!header || header.dataset.mmPromoObserved) return;

    header.dataset.mmPromoObserved = 'true';

    var observer = new MutationObserver(function () {
      scanOpenDesktopPanels(header);
    });

    observer.observe(header, {
      subtree: true,
      attributes: true,
      attributeFilter: ['open'],
    });

    document.addEventListener('mouseover', function (event) {
      var target = eventTargetElement(event);
      if (!target) return;

      var parent = target.closest('.nav-desktop__tier-1-item--widemenu-parent');
      if (!parent || !header.contains(parent)) return;

      var details = parent.querySelector('[data-nav-desktop-details]');
      loadDesktopPanelImages(details);
    }, true);

    scanOpenDesktopPanels(header);
  }

  var mobilePromosLoaded = false;
  var mobileMenuObserved = false;

  function loadMobilePromosOnce() {
    if (mobilePromosLoaded) return;
    mobilePromosLoaded = true;
    // Drawer open is not enough — wait until a group expands (YTMegaMenuImages.load).
  }

  function observeMobileMenu() {
    // init() can run more than once — never stack body observers.
    if (mobileMenuObserved || !document.body) return;
    mobileMenuObserved = true;

    var bodyObserver = new MutationObserver(function () {
      if (document.body.classList.contains('mobile-menu-open')) {
        loadMobilePromosOnce();
        bodyObserver.disconnect();
      }
    });

    bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  function hookMeganavInject() {
    if (!window.meganavManager || window.meganavManager.__mmPromoHooked) return;

    var originalInjectAll = window.meganavManager.injectAll.bind(window.meganavManager);

    window.meganavManager.injectAll = function () {
      originalInjectAll();
      if (!isNarrow()) {
        scanOpenDesktopPanels(document.querySelector('[data-desktop-header]') || document);
      }

      if (document.readyState === 'complete') {
        scheduleBackgroundPrefetch();
      }
    };

    window.meganavManager.__mmPromoHooked = true;
  }

  function init() {
    if (!isNarrow()) {
      observeDesktopMegaMenus();
    }
    observeMobileMenu();
    hookMeganavInject();
  }

  // Used by yt-mobile-menu.js to load a group's images when it is expanded.
  window.YTMegaMenuImages = {
    load: loadDeferredImages
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  if (document.readyState === 'complete') {
    scheduleBackgroundPrefetch();
  } else {
    window.addEventListener('load', scheduleBackgroundPrefetch);
  }

  document.addEventListener('shopify:section:load', function () {
    if (!isNarrow()) {
      observeDesktopMegaMenus();
      scanOpenDesktopPanels(document.querySelector('[data-desktop-header]') || document);
    }
    hookMeganavInject();

    if (document.readyState === 'complete') {
      scheduleBackgroundPrefetch();
    }
  });

  setTimeout(init, 0);
  setTimeout(function () {
    hookMeganavInject();
    if (!isNarrow()) {
      scanOpenDesktopPanels(document.querySelector('[data-desktop-header]') || document);
    }
  }, 500);
})();
